module.exports = __webpack_public_path__ + "img/shopping_cart@4x.4d5f4625.png";